const getCompany = state => state.company;

export default {
  getCompany,
};
